import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=1289c060&scoped=true&"
import script from "./FileSelector.vue?vue&type=script&lang=js&"
export * from "./FileSelector.vue?vue&type=script&lang=js&"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=1289c060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289c060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
